import React from "react";

import classnames from "classnames";
import LockImage from "images/intuit-landing-lock-icon.png";
import makeResponsiveBem from "Utils/makeResponsiveBem";
import SIReactOnRails from "Utils/ReactOnRails";

import { BodyMedium } from "Cobalt/BodyText";
import { getBreakpoint } from "Common/Responsive";

import makeBem from "Utils/makeBem";

const bem = makeBem("SecurityBox");
const responsiveBem = makeResponsiveBem("SecurityBox");
export default class SecurityBox extends React.Component {
  render() {
    return (
      <div className={classnames(bem(), responsiveBem())}>
        <div className={responsiveBem("ImageContainer")}>
          <img className={responsiveBem("image")} src={LockImage} alt="Landing Lock" />
        </div>
        <BodyMedium className={responsiveBem("text")}>
          {getBreakpoint() === "xs"
            ? "We encrypt your data and never share it."
            : "Data security and privacy is SimplyInsured's top priority.  We encrypt " + "your personal information securely and never share it."}
        </BodyMedium>
      </div>
    );
  }
}
SIReactOnRails.register(
  {
    SecurityBox,
  },
  module,
);
